module.exports = __webpack_public_path__ + "static/media/nutricia-logo.a42a6b61.svg";